var map = {
	"./de-DE/education": 81189,
	"./en-US/education": 6022,
	"./es-ES/education": 77859,
	"./fa-IR/education": 65227,
	"./fr-FR/education": 78287,
	"./hi-IN/education": 31781,
	"./it-IT/education": 85197,
	"./ja-JP/education": 31894,
	"./ko-KR/education": 49668,
	"./pl-PL/education": 17731,
	"./pt-BR/education": 53291,
	"./ro-RO/education": 81773,
	"./ru-RU/education": 80305,
	"./sl-SI/education": 16734,
	"./th-TH/education": 795,
	"./tr-TR/education": 77787,
	"./uk-UA/education": 81053,
	"./vi-VN/education": 60216,
	"./zh-Hans/education": 68721,
	"./zh-Hant/education": 78840
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53605;